import React from "react"
import { Link } from "gatsby"
import styled from "@emotion/styled"
import { useForm } from "react-hook-form";

// css
const FormContainer = styled.div`
  width: 680px;
  display: flex;
  justify-content: center;
  @media screen and (max-width: 799px) {
    width: 100%;
    /* padding: 0 16px; */
  }
`

const Group = styled.div`
  position: relative;
  height: 56px;
  width: 680px;
  margin-bottom: 32px;
  display: flex;
  justify-content: left;
  align-items: start;
  @media screen and (max-width: 799px) {
    flex-direction: column;
    height: 88px;
    width: 100%;
  }
`

const LabelContainer = styled.div`
  height: 56px;
  width: 230px;
  padding: 16px 16px 0 0;
  display: flex;
  justify-content: end;
  @media screen and (max-width: 799px) {
    justify-content: start;
    padding-bottom: 8px;
    padding-top: 0;
    height: auto;
  }
`

const Label = styled.label`
  color: #222222;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
  text-align: right;
`

const Requred = styled.div`
  height: 24px;
  width: 49px;
  margin-left: 8px;
  border-radius: 4px;
  background-color: #dd0000;
  /* box-shadow: 0 0 16px 0 rgba(0,0,0,0.15); */
  color: #ffffff;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.3px;
  line-height: 24px;
  text-align: center;
`

const Input = styled.input`
  box-sizing: border-box;
  height: 56px;
  width: 479px;
  border: 1px solid rgba(0, 0, 0, 0.32);
  border-radius: 4px;
  padding-left: 16px;
  color: #000000;
  font-size: 16px;
  letter-spacing: 0.15px;
  line-height: 56px;
  @media screen and (max-width: 799px) {
    width: 100%;
  }
`

const Triangle = styled.div`
  position: absolute;
  content: "";
  z-index: -1;
  bottom: 23px;
  right: 20px;
  border-top: 7px solid #000000;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  @media screen and (max-width: 799px) {
    right: 10px;
  }
`

const Select = styled.select`
  box-sizing: border-box;
  height: 56px;
  width: 479px;
  border: 1px solid rgba(0, 0, 0, 0.32);
  border-radius: 4px;
  padding-left: 16px;
  color: #000000;
  font-size: 16px;
  letter-spacing: 0.15px;
  line-height: 56px;
  // スタイル削除
  appearance: none;
  --webkit-appearance: none;
  --moz-appearance: none;
  background: transparent;
  &:invalid {
    color: grey;
  }
  @media screen and (max-width: 799px) {
    height: 56px;
    width: 100%;
  }
`
const GroupTextarea = styled.div`
  height: 274px;
  width: 680px;
  margin-bottom: 32px;
  display: flex;
  justify-content: end;
  align-items: start;
  @media screen and (max-width: 799px) {
    flex-direction: column;
    height: 314px;
    width: 100%;
  }
`

const Textarea = styled.textarea`
  box-sizing: border-box;
  height: 274px;
  width: 479px;
  padding-top: 17px;
  border: 1px solid rgba(0, 0, 0, 0.32);
  border-radius: 4px;
  padding-left: 16px;
  color: #000000;
  font-size: 16px;
  letter-spacing: 0.15px;
  line-height: 24px;
  @media screen and (max-width: 799px) {
    height: 274px;
    width: 100%;
  }
`
const Button = styled.button`
  height: 45px;
  width: 280px;
  margin: 0 0 32px 202px;
  border-radius: 22.5px;
  border: none;
  background-color: #2130ab;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.15);
  color: #ffffff;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.42px;
  line-height: 45px;
  text-align: center;
  @media screen and (max-width: 799px) {
    width: 80%;
    margin-left: 10%;
  }
`

const TextContainer = styled.div`
  width: 588px;
  margin-left: 48px;
  @media screen and (max-width: 799px) {
    width: 100%;
    margin-left: 0px;
  }
`

const Text = styled.p`
  color: #222222;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
`

const encode = (data) => {
  return Object.keys(data)
  .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
  .join("&");
}

// component
const ContactForm = (props) => {
  const {
    register,
    handleSubmit,
    formState: {errors}
  } = useForm()

  const onSubmit = (data) => {
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact", ...data })
    })
    .then(() => {
      props.setIsSubmitted(true)
    })
    .catch((error) => {
      // todo: エラーハンドリング
    });
  }

  // 固定電話の電話番号:
  //     0X-XXXX-XXXX
  //     0XX-XXX-XXXX
  //     0XXX-XX-XXXX
  //     0XXXX-X-XXXX
  // 携帯電話の電話番号: 0X0-XXXX-XXXX
  const telRegex =
    "^(0[5-9]0-[0-9]{4}-[0-9]{4}|0([0-9]-[0-9]{4}|[0-9]{2}-[0-9]{3}|[0-9]{3}-[0-9]{2}|[0-9]{4}-[0-9])-[0-9]{4}|0[0-9]{10}|0[0-9]{9})$"
  
    return (
    <FormContainer>
      <form name="contact" method="POST" data-netlify="true" onSubmit={handleSubmit(onSubmit)}>
        <input type="hidden" name="form-name" value="contact" />
        <Group>
          <LabelContainer>
            <Label>お名前</Label>
            <Requred>必須</Requred>
          </LabelContainer>
          <Input
            name="お名前"
            type="text"
            placeholder="例）山田太郎"
            required
            {...register("name", {required: true})}
          />
        </Group>
        <Group>
          <LabelContainer>
            <Label>会社/学校名</Label>
          </LabelContainer>
          <Input
            name="会社/学校名"
            type="text"
            placeholder="例）株式会社アクア"
            {...register("company", {required: true})}
          />
        </Group>
        <Group>
          <LabelContainer>
            <Label>電話番号</Label>
          </LabelContainer>
          <Input
            name="電話番号"
            type="tel"
            placeholder="例）03-0000-0000"
            pattern={telRegex}
            {...register("telNumber", {required: true})}
          />
        </Group>
        <Group>
          <LabelContainer>
            <Label>メールアドレス</Label>
            <Requred>必須</Requred>
          </LabelContainer>
          <Input
            name="メールアドレス"
            type="email"
            placeholder="例）aaa@example.com"
            required
            pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
            {...register("email", {required: true})}
          />
        </Group>
        <Group>
          <LabelContainer>
            <Label>お問い合わせの種類</Label>
            <Requred>必須</Requred>
          </LabelContainer>
          <Select name="お問い合わせの種類" required {...register("inquiryType", {required: true})}>
            <option value="" disabled selected hidden>
              お問い合わせの種類を選択してください。
            </option>
            <option value="高速システム開発">高速システム開発</option>
            <option value="クラウドシステム構築">クラウドシステム構築</option>
            <option value="システム保守･運用">システム保守･運用</option>
            <option value="インフラ構築･Office365導入">
              インフラ構築･Office365導入
            </option>
            <option value="IT･DX推進コンサルティング">
              IT･DX推進コンサルティング
            </option>
            <option value="AIエンジン開発">AIエンジン開発</option>
            <option value="採用に関して">採用に関して</option>
            <option value="その他">その他</option>
          </Select>
          <Triangle></Triangle>
        </Group>
        <GroupTextarea>
          <LabelContainer>
            <Label>お問い合わせの内容</Label>
            <Requred>必須</Requred>
          </LabelContainer>
          <Textarea
            name="お問い合わせの内容"
            placeholder="お問い合わせの内容をご入力ください。"
            required
            {...register("inquiryBody", {required: true})}
          />
        </GroupTextarea>
        <Button type="submit">送信する</Button>
        <TextContainer>
          <Text>
            個人情報の取り扱いに関しては
            <Link
              to="/privacy"
              style={{ textDecoration: "underline", color: "#222222" }}
            >
              プライバシーポリシー
            </Link>
            をお読みいただき、同意のうえお問い合わせください。
          </Text>
        </TextContainer>
      </form>
    </FormContainer>
  )
}

export default ContactForm
